import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Dashboard } from './pages/Dashboard';
import { OrdersList } from './pages/OrdersList';
import { OrderDetail } from './pages/OrderDetail';
import { CustomersList } from './pages/CustomersList';
import { CustomerDetail } from './pages/CustomerDetail';
import { PhotosList } from './pages/PhotosList';
import { PhotoEdit } from './pages/PhotoEdit';
import { PrintSizes } from './pages/PrintSizes';
import { Settings } from './pages/Settings';
import { Coupons } from './pages/Coupons';
import { SupportList } from './pages/SupportList';
import { SupportCase } from './pages/SupportCase';
import { Emails } from './pages/Emails';
import { EmailEdit } from './pages/EmailEdit';
import { AboutEdit } from './pages/AboutEdit';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="orders" element={<OrdersList />} />
        <Route path="orders/:uuid" element={<OrderDetail />} />
        <Route path="customers" element={<CustomersList />} />
        <Route path="customers/:uuid" element={<CustomerDetail />} />
        <Route path="photos" element={<PhotosList />} />
        <Route path="photos/new" element={<PhotoEdit />} />
        <Route path="photos/:uuid" element={<PhotoEdit />} />
        <Route path="about" element={<AboutEdit />} />
        <Route path="print-sizes" element={<PrintSizes />} />
        <Route path="settings" element={<Settings />} />
        <Route path="coupons" element={<Coupons />} />
        <Route path="support" element={<SupportList />} />
        <Route path="support/:uuid" element={<SupportCase />} />
        <Route path="emails" element={<Emails />} />
        <Route path="emails/:type" element={<EmailEdit />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
